import { render, staticRenderFns } from "./AnalysesPopularSection.vue?vue&type=template&id=af841fd0&scoped=true&"
import script from "./AnalysesPopularSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesPopularSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesPopularSection.vue?vue&type=style&index=0&id=af841fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af841fd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af841fd0')) {
      api.createRecord('af841fd0', component.options)
    } else {
      api.reload('af841fd0', component.options)
    }
    module.hot.accept("./AnalysesPopularSection.vue?vue&type=template&id=af841fd0&scoped=true&", function () {
      api.rerender('af841fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesPopularSection.vue"
export default component.exports